<template>
  <div class="credits">
    <div class="relative">
      <SearchComponent
        ref="search"
        :condition="condition"
        :routeName="$route.name"
      />
      <TableComponent
        :tableData="tableData"
        :routeName="$route.name"
        :pagination="pagination"
        @updateData="_updateData"
      >
        <template #btn>
          <el-button
            class="export-color"
            v-html="'导出对账单'"
            v-permission:export="$route.meta.permission"
          />
        </template>
        <template #default="{editor,handleSelectionChange}">
          <el-table
            :data="tableData"
            v-min-height
            @selection-change="handleSelectionChange"
            header-cell-class-name="theader-th"
            cell-class-name="tbody-td"
            :height="500"
          >
            <el-table-column
              align="center"
              width="130"
              type="selection"
              fixed
            />
            <el-table-column
              label="初始信用额度"
              align="center"
              min-width="180"
            >
              <template slot-scope="scope">
                {{ scope.row.initAmount | formatMoney }}
              </template>
            </el-table-column>
            <el-table-column
              label="本月订单总金额"
              align="center"
              min-width="180"
            >
              <template slot-scope="scope">
                {{ scope.row.orderAmount | formatMoney }}
              </template>
            </el-table-column>
            <el-table-column
              label="本月已结算金额"
              align="center"
              min-width="180"
            >
              <template slot-scope="scope">
                {{ scope.row.settlementAmount | formatMoney }}
              </template>
            </el-table-column>
            <el-table-column
              label="本月剩余额度"
              align="center"
              min-width="180"
            >
              <template slot-scope="scope">
                {{ scope.row.remainAmount | formatMoney }}
              </template>
            </el-table-column>
            <el-table-column
              label="上月未结算金额"
              align="center"
              min-width="180"
            >
              <template slot-scope="scope">
                {{ scope.row.noSettlementAmount | formatMoney }}
              </template>
            </el-table-column>
            <el-table-column label="额度状态" align="center" min-width="180">
              <template slot-scope="scope">
                {{ scope.row.status | formatMoney }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="操作"
              min-width="180"
              fixed="right"
              class-name="visible"
            >
              <template slot-scope="scope">
                <div class="winner-flex">
                  <el-button
                    v-permission:details="$route.meta.permission"
                    class="iconfont icon-chakanxiangqing d5"
                    round
                    size="36"
                  />
                  <div class="dots-all">
                    <p
                      class="dots"
                      @click="editor('', 'adjustCredits')"
                      v-permission:credit="$route.meta.permission"
                    >
                      调整额度
                    </p>
                    <p
                      class="dots"
                      @click="editor('', 'settlement')"
                      v-permission:settlement="$route.meta.permission"
                    >
                      结算贷款
                    </p>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </TableComponent>
      <div class="mask" v-show="dialogVisible">
        <el-dialog
          :visible.sync="dialogVisible"
          :modal-append-to-body="false"
          :close-on-press-escape="false"
          :modal="false"
          width="60%"
          custom-class="dialog"
          :center="true"
        >
          <fragment slot="title">
            <h3 class="title">
              {{ operatorType === 'settlement' ? '结算贷款' : '调整额度' }}
            </h3>
          </fragment>
          <el-form label-width="auto" :model="form" style="margin-right: 5rem">
            <el-form-item label="企业名称：">
              <div class="input">
                <el-input
                  v-model="form.companyName"
                  placeholder="请输入"
                  clearable
                />
              </div>
            </el-form-item>
            <fragment v-if="operatorType === 'adjustCredits'">
              <el-form-item label="初始信用额度：">
                <div class="input">
                  <el-input
                    v-model="form.initCredits"
                    placeholder="请输入"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item label="调整额度：">
                <div class="input">
                  <el-input
                    v-model="form.adjustCredits"
                    placeholder="请输入"
                    clearable
                  />
                </div>
              </el-form-item>
            </fragment>
            <fragment v-if="operatorType === 'settlement'">
              <el-form-item label="贷款结算时间：">
                <div class="input">
                  <el-input
                    v-model="form.time"
                    placeholder="请输入"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item label="已结算总金额：">
                <div class="input">
                  <el-input
                    v-model="form.settlementAmount"
                    placeholder="请输入"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item label="未结算金额：">
                <div class="input">
                  <el-input
                    v-model="form.noSettlementAmount"
                    placeholder="请输入"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item label="本月还需结算金额：">
                <div class="input">
                  <el-input
                    v-model="form.remainAmount"
                    placeholder="请输入"
                    clearable
                  />
                </div>
              </el-form-item>
            </fragment>
            <el-form-item label="付款流水单号：">
              <div class="input">
                <el-input v-model="form.odd" placeholder="请输入" clearable />
              </div>
            </el-form-item>
            <el-form-item label="回单编号：">
              <div class="input">
                <el-input v-model="form.num" placeholder="请输入" clearable />
              </div>
            </el-form-item>
            <el-form-item label="充值操作人：">
              <div class="input">
                <el-input
                  v-model="form.operator"
                  placeholder="请输入"
                  clearable
                />
              </div>
            </el-form-item>
          </el-form>
          <el-form label-width="auto" :model="form">
            <el-form-item label="上传付款凭证：">
              <el-upload
                class="upload"
                action="/"
                :auto-upload="false"
                :show-file-list="false"
                :file-list="form.fileList"
                :on-change="handleChange"
              >
                <img
                  v-if="form.imageUrl"
                  :src="form.imageUrl"
                  class="preview-img"
                />
                <div class="winner-flex" v-if="!form.imageUrl">
                  <el-button size="36" class="iconfont icon-tupian d5" round />
                  <span class="tips">
                    上传附件
                  </span>
                </div>
                <div class="opearting" v-if="form.imageUrl">
                  <span class="change">更换</span>
                  <i @click.stop="delImg" class="iconfont icon-shanchu" />
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="备注说明：">
              <el-input
                type="textarea"
                v-model="form.remark"
                clearable
                size="200"
                resize="none"
                placeholder="请输入"
                :autosize="{ minRows: 5, maxRows: 7 }"
              />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button
              class="main-color"
              size="98"
              @click="dialogVisible = false"
            >
              取 消
            </el-button>
            <el-button class="sub-color" size="98">
              确 定
            </el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import SearchComponent from '../Components/SearchComponent'
import TableComponent from '../Components/TableComponent'
import updateData from 'mixins/updateData'

export default {
  name: 'credits',
  mixins: [updateData],
  components: {
    SearchComponent,
    TableComponent
  },
  data() {
    return {
      dialogImageUrl: '',
      operatorType: 'settlement',
      dialogVisible: false,
      condition: {},
      tableData: [
        {
          companyCnName: '深圳前海玖加电子商务有限公司',
          companyEnName:
            'Shenzhen Qianhai Jiujia Electronic \n' + 'Commerce Co.,LTD',
          code: '914402265423547220',
          time: '2019-01-25',
          initAmount: 2000,
          orderAmount: 2000,
          settlementAmount: 2000,
          remainAmount: 2000,
          noSettlementAmount: 2000,
          status: '未超额度'
        }
      ],
      pagination: {
        currentPage: 1,
        pageTotal: 19,
        recordTotal: 80
      },
      form: {
        fileLis: [],
        imageUrl: ''
      }
    }
  },
  created() {},
  methods: {
    /**
     * 文件上传改变
     * @param file
     */
    handleChange(file) {
      this.form.imageUrl = URL.createObjectURL(file.raw)
    },
    /**
     * 删除图片
     */
    delImg() {
      this.form.imageUrl = ''
    }
  }
}
</script>
<style lang="scss">
.credits {
  .el-table {
    .winner-flex {
      button {
        margin-right: 1.5rem;
      }

      .dots {
        &:before {
          left: -0.8rem;
        }
      }
    }
  }

  .title {
    font-size: 1.3rem;
    font-weight: bold;
  }

  .upload {
    width: 12.5rem;
    height: 12.5rem;
    border: 0;
    background-color: #f7f7f7;
    line-height: initial;
    @extend .winner-flex;
    overflow: hidden;

    .winner-flex {
      height: 100%;
      flex-direction: column;
    }

    .opearting {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 1.9rem;
      background-color: rgba(0, 0, 0, 0.6);
      display: flex;
      align-items: center;

      .change {
        width: 2.5rem;
        height: 1.3rem;
        line-height: 1.3rem;
        background-color: colors('bg-sub');
        border-radius: 0.6rem;
        display: inline-block;
        color: #fff;
        margin: 0 1.3rem 0 1.1rem;
      }

      .icon-shanchu {
        font-size: 1.1rem;
        color: #fff;
      }
    }

    .tips {
      padding-top: 0.5rem;
    }
  }

  .el-input--200 {
    width: 12.5rem;
    display: block;
    margin: 0 auto;

    .el-textarea__inner {
      background-color: #f7f7f7;
      border: 0;
      min-height: 13rem !important;
    }
  }
}
</style>
